import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

import { LocationAllRelations } from 'types';

export const getLocationHistory = async (
  locationId: number | null | undefined,
  begin: string | null,
  end: string
): Promise<LocationAllRelations | undefined> => {
  if (
    locationId === null ||
    locationId === undefined ||
    locationId < 1 ||
    begin === null
  )
    return;
  const { data } = await axios.get(
    `/api/locations/${locationId}/history/${begin}/${end}`
  );
  return data as LocationAllRelations;
};

type QueryFnType = typeof getLocationHistory;

type UseLocationOptions = {
  locationId: number | null | undefined;
  begin: string | null;
  end: string;
  config?: QueryConfig<QueryFnType>;
};

export const useLocationHistory = ({
  locationId,
  begin,
  end,
  config,
}: UseLocationOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['locations', locationId, begin, end],
    queryFn: () => getLocationHistory(locationId, begin, end),
  });
};
